import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, useContext } from "react";
import { LayoutPreselectContext, LayoutStrategyWithFallback, } from "@plansoft-configuration-renderer/layout";
import { LayoutLoadingIndicator } from "./LayoutLoadingIndicator";
import { SimpleAttributeStrategy } from "./SimpleAttributeStrategy";
/**
 * Display the attributes using layout editor
 *
 * ***Important:***
 * Use the `ConfigurationController` to enable use of the attribute context
 */
export function LayoutAttributeStrategy(props) {
    const { LoadingIndicator = LayoutLoadingIndicator } = props;
    const layoutId = useContext(LayoutPreselectContext);
    // use layout id here and set to undefined below
    return (_jsx(LayoutPreselectContext.Provider, { value: undefined, children: _jsx(Suspense, { fallback: _jsx(LayoutLoadingIndicator, {}), children: _jsx(LayoutStrategyWithFallback, { FallbackStrategy: SimpleAttributeStrategy, LoadingIndicator: LoadingIndicator, layoutId: layoutId }) }) }));
}
//# sourceMappingURL=LayoutAttributeStrategy.js.map